<template>
    <div class="module-time-tracker">
        <template v-if="!date">
            <form-row label="Datum wählen: " error-name="date" required class="no-margin flex-auto full-width spacer-right-10">
                <form-input-date type="date" v-model="newDate" max="yesterday" hide-clear/>
            </form-row>
        </template>

        <hr v-if="!date">

        <template v-if="variantPrompt && date || variantPrompt && newDate !== ''">
           Wollen Sie eine Korrektur Ihrer Projektzeiten vornehmen? Arbeitszeitkorrekturen können<template v-if="!requestAtWork"> nicht während der Arbeit und</template> erst am folgenden Tag beantragt werden.
        </template>
        <template v-else-if="loading && !date && newDate === ''">
            Geben Sie zum fortfahren ein Datum ein.
        </template>
        <loading-indicator v-else-if="loading"/>
        <template v-else-if="isProjectCorrection">
            <div v-if="projectWorkTimeOptions.correction.length" id="time-tracker-project-correction-wrapper">
                <div class="row">
                    <div class="col-4">
                        <div class="padding-10 border-bottom">
                            <strong>Projekt auswählen</strong>
                        </div>
                    </div>

                    <div v-if="date" class="col-8">
                        <div class="padding-10 border-bottom text-center">
                            <strong>{{dateDayName}} {{dateHelper('d.m.Y', date)}}</strong>
                        </div>
                    </div>
                </div>

                <hr>

                <div class="row">
                    <div ref="projectSelect" class="col-4 project-select overflow-y-scroll" @scroll="updateProjectSelectDimensions()" @resize="updateProjectSelectDimensions()">
                        <template v-for="timeEntryOption in projectWorkTimeOptions.correction">
                            <div v-if="timeEntryOption.value === correctionProjectEntryIds" v-bind="timeEntryOption.attributes" class="project-option project-option-active" v-tooltip>
                                <div class="project-option-label">
                                    {{newProjectBeginStamp}} bis {{newProjectEndStamp}}:
                                    <br>
                                    {{projectPairs[correctionProjectId]}} ({{correctionContactId.label}})
                                </div>

                                <template v-for="frameChange in projectFrameChanges">
                                    <div v-if="frameChange" class="project-option-label-sub">
                                        <template v-if="hasProject">
                                            &#8226;&nbsp; {{projectPairs[frameChange.projectId] || 'Projekt wählen'}} - {{frameChange.begin}} bis {{frameChange.end}}
                                        </template>
                                        <template v-else class="project-option-label-sub">
                                            &#8226;&nbsp; {{frameChange.contactId.label || 'Kontakt wählen'}} - {{frameChange.begin}} bis {{frameChange.end}}
                                        </template>
                                    </div>
                                </template>
                            </div>
                            <div v-else v-bind="timeEntryOption.attributes" class="project-option" v-tooltip>
                                <div v-interact="() => setCorrectionProjectEntryIds(<string>timeEntryOption.value)" class="project-option-label">
                                    {{timeEntryOption.label}}
                                </div>
                            </div>
                        </template>

                        <div ref="projectSelectMore" v-if="projectSelectScrollable && !projectSelectScrollY" class="project-option project-select-more">
                            <div class="project-option-label font-weight-500 color-link" v-interact="scrollToNextProjects">
                                <i aria-hidden="true" class="material-icons" role="img">expand_more</i>
                                <span>Weitere Projekte</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-8">
                        <form v-if="correctionProjectEntryIds" ref="correctionForm" class="margin-top-20">
                            <input type="hidden" :value="correctionTypes.editProject" name="correction_setting"/>
                            <input type="hidden" :value="correctionProjectEntryIds" name="project_entry_ids"/>

                            <div class="flex flex-wrap">
                                <form-row v-if="hasProject" label="Projekt wechseln" error-name="project_id" required class="no-margin flex-auto full-width spacer-right-10">
                                    <form-select v-model="correctionProjectId" :options="projectOptions" name="project_id" class="full-width"/>
                                </form-row>

                                <form-row v-if="hasContact" label="Kontakt wechseln" error-name="contact_id" required style="min-width: 250px;"
                                    class="no-margin full-width spacer-right-10">
                                    <input type="hidden" v-model="correctionContactId.value" name="contact_id"/>
                                    <app-search-tiny ref="institutionSearch" @apply="setCorrectionContact" :clearable="!!correctionContactId.value"
                                        :placeholder="correctionContactId.label" @clear="setCorrectionContact"
                                        search-url="/application/ajax/get-contact-suggestions"/>
                                </form-row>

                                <form-row label="Beginn ändern" error-name="new_project_begin_stamp" required required-manually class="no-margin flex-min-content spacer-right-10">
                                    <form-input-date v-model="newProjectBeginStamp" type="time" name="new_project_begin_stamp"
                                        aria-label="Angabe der neuen Zeit" v-bind="minMaxProjectTimes.begin" class="time-input-width"/>
                                </form-row>

                                <form-row label="Ende ändern" error-name="new_project_end_stamp" required required-manually class="no-margin flex-min-content spacer-right-10">
                                    <form-input-date v-model="newProjectEndStamp" type="time" name="new_project_end_stamp"
                                        aria-label="Angabe der neuen Zeit" v-bind="minMaxProjectTimes.end" class="time-input-width"/>
                                </form-row>

                                <div class="label-padding-top input-line-height">
                                    <span v-interact="removeProjectEntry" aria-label="Auf Projektlücke setzen" class="icon-interact"
                                        title="Auf Projektlücke setzen" :class="{'mark-deleted': !correctionProjectId}">
                                        <i v-tooltip aria-hidden="true" class="material-icons text-danger" role="img">delete</i>
                                    </span>
                                </div>
                            </div>

                            <template v-for="(projectChange, $key) in projectFrameChanges">
                                <template v-if="projectChange">
                                    <div class="hrline-text margin-top-20 margin-bottom-30">
                                        <span>Folgeänderung {{$key === 'before' ? 'davor' : 'danach'}}</span>
                                    </div>

                                    <div class="flex margin-bottom-15 flex-wrap">
                                        <form-row v-if="hasProject" label="Projekt" :error-name="'project_' + $key" required class="no-margin flex-auto full-width spacer-right-10">
                                            <form-select v-model="projectChange.projectId" :options="projectOptions" class="full-width"
                                                :name="$key === 'before' ? 'project_before' : 'project_after'"/>
                                        </form-row>

                                        <form-row v-if="hasContact" label="Kontakt wechseln" :error-name="'contact_' + $key" required style="min-width: 250px;"
                                            class="no-margin full-width spacer-right-10">
                                            <input type="hidden" v-model="projectChange.contactId.value" :name="$key === 'before' ? 'contact_before' : 'contact_after'"/>
                                            <app-search-tiny :ref="'institutionSearch_' + $key"
                                                :placeholder="projectChange.contactId.label"
                                                @apply="(entry) => changeCorrectionContact($key, entry)"
                                                :clearable="projectChange.contactId.value"
                                                @clear="changeCorrectionContact($key)"
                                                search-url="/application/ajax/get-contact-suggestions"/>
                                        </form-row>

                                        <form-row label="Beginn" class="no-margin flex-min-content spacer-right-10 validate-spacer">
                                            <div class="input-line-height time-input-width padding-left-10">
                                                <strong class="label">{{projectChange.begin}}</strong>
                                            </div>
                                        </form-row>

                                        <form-row label="Ende" class="no-margin flex-min-content spacer-right-10 validate-spacer">
                                            <div class="input-line-height time-input-width padding-left-10">
                                                <strong class="label">{{projectChange.end}}</strong>
                                            </div>
                                        </form-row>

                                        <div class="label-padding-top input-line-height">
                                            <span v-interact="() => removeProjectFrameChange($key)" aria-label="Auf vorherige Zeit zurücksetzen"
                                                :title="($key === 'before' ? 'Beginn' : 'Ende') + ' auf vorherige Zeit zurücksetzen'" class="icon-interact">
                                                <i v-tooltip aria-hidden="true" class="material-icons text-danger" role="img">delete</i>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </form>
                        <portuna-box v-else class="disclaimer margin-top-20">
                            <p>Bitte wählen Sie zunächst einen Projektzeitraum aus.</p>
                        </portuna-box>
                    </div>
                </div>
            </div>
            <portuna-box v-else class="disclaimer">
                <strong>Hinweis:</strong>
                <p>Es gibt an diesem Tag keine Einträge, die korrigiert werden könnten!</p>
            </portuna-box>
        </template>
        <template v-else>
            <div v-if="date" class="text-center">
                <strong>{{dateDayName}} {{dateHelper('d.m.Y', date)}}</strong>
            </div>

            <template v-if="0 !== timeEntries.length">
                <form ref="correctionForm">
                    <form-row label="Korrekturart wählen:" error-name="correction_setting" required>
                        <form-select v-model="correctionType" :options="correctionTypeOptions" name="correction_setting"/>
                    </form-row>

                    <hr>

                    <div v-if="correctionTypes.edit === correctionType" class="row">
                        <div v-if="allowWorkOutsideWorkTime">
                            <div class="status-messages">
                                <div v-if="!workDays[dayName]" class="info margin-10">
                                    <i aria-hidden="true" class="material-icons md-light" role="img">info</i>
                                    <p> Sie können Werte für {{dateHelper('D, d.m.Y', date)}} eintragen, aber diese werden nicht auf Ihre wöchentliche Arbeitszeit angerechnet, da Ihre eingestellten Arbeitstage <strong> {{workDaysList.days}} </strong> sind.</p>
                                </div>
                            </div>
                        </div>
                        <div v-if="allowWorkOutsideWorkTime && (!calculateBeforeWorkStart || !calculateAfterWorkEnd)">
                            <div class="status-messages">
                                <div v-if="workDays[dayName] && (!calculateBeforeWorkStart && correctionNewStamp < workDays[dayName]?.start && correctionNewStamp !== '') || (!calculateAfterWorkEnd && correctionNewStamp > workDays[dayName]?.end && correctionNewStamp !== '')" class="info margin-10">
                                    <i aria-hidden="true" class="material-icons md-light" role="img">info</i>
                                    Sie können Werte für {{dateHelper('D, d.m.Y', date)}} eintragen, aber diese werden Ihrer wöchentlicher Arbeitszeit nicht angerechnet, da Ihr eingestellter Arbeitzeitraum von {{workDaysList.times}} ist.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <form-row label="Zu korrigierender Eintrag:" error-name="entryId" required>
                                <form-select v-model="correctionEntryId" :options="timeEntryOptions" name="entryId"/>
                            </form-row>
                        </div>

                        <div class="col-md-6">
                            <form-row label="Neue Zeit:" error-name="new_stamp" :required="newStampRequired" required-manually>
                                <div class="row">
                                    <div class="col-lg-4">
                                        <form-input-date v-model="correctionNewStamp" type="time" name="new_stamp" :disabled="correctionDisabled"
                                            aria-label="Angabe der neuen Zeit"/>
                                    </div>
                                </div>
                            </form-row>
                        </div>
                    </div>
                    <div v-else-if="correctionTypes.addBreak === correctionType" class="row">
                        <div class="col-md-6">
                            <form-row label="Pausenbeginn" error-name="new_break_begin_stamp" required>
                                <form-input-date type="time" name="new_break_begin_stamp"/>
                            </form-row>
                        </div>
                        <div class="col-md-6">
                            <form-row label="Pausenende" error-name="new_break_end_stamp" required>
                                <form-input-date type="time" name="new_break_end_stamp"/>
                            </form-row>
                        </div>
                    </div>
                    <form-row v-else-if="correctionTypes.removeBreak === correctionType" label="Pause wählen" error-name="break" required>
                        <form-select :options="breakOptions" name="break"/>
                    </form-row>

                    <form-row v-if="!noApprovalRequired && !isSuperior && !isProjectCorrection" label="Begründung:" error-name="message" :required="messageRequired"
                        required-manually>
                        <form-textarea name="message" class="textarea-vertical"/>
                    </form-row>
                </form>
            </template>
            <form v-else ref="correctionForm">
                <input type="hidden" name="correction_setting" :value="CORRECTION_ADD_WORK_TIME_AND_BREAKS"/>

                <portuna-box class="disclaimer spacer-15">
                    <strong>Korrekturart:</strong>
                    <span>Fehlende Einträge hinzufügen</span>
                    <div v-if="!calculateNonWorkdays">
                        <div class="status-messages">
                            <div v-if="!workDays[dayName]" class="info margin-10">
                                <i aria-hidden="true" class="material-icons md-light" role="img">info</i>
                                <p> Sie können Werte für {{dateHelper('D, d.m.Y', date)}} eintragen, aber diese werden nicht auf Ihre wöchentliche Arbeitszeit angerechnet, da Ihre eingestellten Arbeitstage <strong> {{workDaysList.days}} </strong> sind.</p>
                            </div>
                        </div>
                    </div>

                    <div v-if="allowWorkOutsideWorkTime && (!calculateBeforeWorkStart || !calculateAfterWorkEnd)">
                        <div class="status-messages">
                            <div v-if="workDays[dayName] && (!calculateBeforeWorkStart && newBegin < workDays[dayName]?.start && newBegin !== '') || (!newEnd && newEnd > workDays[dayName]?.end && newEnd !== '')" class="info margin-10">
                                <i aria-hidden="true" class="material-icons md-light" role="img">info</i>
                                Sie können Werte für {{dateHelper('D, d.m.Y', date)}} eintragen, aber diese werden Ihrer wöchentlicher Arbeitszeit nicht angerechnet, da Ihr eingestellter Arbeitzeitraum von {{workDaysList.times}} ist.
                            </div>
                        </div>
                    </div>

                    <div class="flex">
                        <div class="row spacer-20">
                            <div class="col-6">
                                <form-row label="Arbeitsbeginn" error-name="begin" error-tooltip hide-validator-icon hide-validator>
                                    <form-input-date type="time" v-model="newBegin" name="begin" placeholder="HH:MM"/>
                                </form-row>
                            </div>

                            <div class="col-6">
                                <form-row label="Arbeitsende" error-name="end" error-tooltip hide-validator-icon hide-validator>
                                    <form-input-date type="time" v-model="newEnd" :min="minMaxNewEntries.min" name="end" placeholder="HH:MM"/>
                                </form-row>
                            </div>
                        </div>
                    </div>

                    <fieldset-cloneable v-model="newBreaks">
                        <template #render="{values, $index, manage}">
                            <div class="flex">
                                <div class="row spacer-right-10">
                                    <div class="col-6">
                                        <form-row :label="$index ? '' : 'Pausenbeginn'" :error-name="`breaks.${$index}.begin`" filter-name="breaks.begin"
                                            :required="false" required-manually error-tooltip hide-validator-icon hide-validator>
                                            <form-input-date type="time" v-model="values.begin" v-bind="minMaxNewEntries" :name="`breaks[${$index}][begin]`" placeholder="HH:MM"/>
                                        </form-row>
                                    </div>

                                    <div class="col-6">
                                        <form-row :label="$index ? '' : 'Pausenende'" :error-name="`breaks.${$index}.end`" filter-name="breaks.end" error-tooltip
                                            :required="false" required-manually hide-validator-icon hide-validator>
                                            <form-input-date type="time" v-model="values.end" v-bind="minMaxNewEntries" :name="`breaks[${$index}][end]`" placeholder="HH:MM"/>
                                        </form-row>
                                    </div>
                                </div>

                                <div :class="['input-line-height', {'label-padding-top': !$index}]">
                                    <span v-if="newBreaks.length > 1" v-interact="() => manage.delete($index)" aria-label="Pause löschen" class="icon-interact">
                                        <i v-tooltip aria-hidden="true" class="material-icons text-danger" title="Pause löschen" role="img">delete</i>
                                    </span>

                                    <span v-if="$index === newBreaks.length - 1" v-interact="manage.add" aria-label="Pause hinzufügen"
                                        class="icon-interact visible-sm-inline-block-upward">
                                        <i v-tooltip aria-hidden="true" class="material-icons text-add" title="Pause hinzufügen" role="img">add</i>
                                    </span>
                                </div>
                            </div>
                        </template>

                        <template #addButton="{add}">
                            <div v-interact="add" class="button button-add spacer-15 visible-xs">
                                <i aria-hidden="true" class="material-icons" role="img">add</i>

                                <span>Pause hinzufügen</span>
                            </div>
                        </template>
                    </fieldset-cloneable>

                    <form-row v-if="!isSuperior" label="Begründung" error-name="message" required required-manually>
                        <form-textarea name="message" class="textarea-vertical"/>
                    </form-row>
                </portuna-box>
            </form>
        </template>
    </div>
</template>

<script lang="ts">
    import AppSearchTiny from '@/components/AppSearchTiny.vue';
    import DateRangeSelect from '@/components/DateRangeSelect.vue';
    import {dayNames, dayNamesEn, getDateInformation, getDayName} from '@/library/date';
    import {
        BREAK_BEGIN,
        BREAK_END,
        CORRECTION_ADD_WORK_TIME_AND_BREAKS,
        getWorkDaysAndHoursStringByWorkDays,
        WORK_BEGIN,
        WORK_END,
    } from '@/library/modules/time-tracker/time-tracker';
    import {applyChangesPrompt} from '@/library/utils';
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';
    import {namespace} from 'vuex-facing-decorator';
    import FieldsetCloneable from '../../../components/FieldsetCloneable.vue';
    import FormInputDate from '../../../components/form/FormInputDate.vue';
    import FormRow from '../../../components/form/FormRow.vue';
    import FormSelect from '../../../components/form/FormSelect.vue';
    import FormTextarea from '../../../components/form/FormTextarea.vue';
    import LoadingIndicator from '../../../components/LoadingIndicator.vue';
    import PortunaBox from '../../../components/PortunaBox.vue';
    import {formSubmit, getFormData, parseFormData} from '../../../library/form';
    import {timeTrackerEntryTypes} from '../../../library/modules/time-tracker/time-tracker';
    import {popupDefaultCancelButton, popupDefaultCloseButton} from '../../../library/popup';
    import TopMessageHandler from '../../../library/topMessageHandler';
    import {errorHandler, XHR_STATUS_DEFAULT} from '../../../utils/portuna';
    import dateHelper from '../../../utils/portuna/dateHelper';

    const TimeTrackerStore = namespace('timeTracker');
    type CorrectionVariant = 'time' | 'project';

    type ProjectFrameChange = { projectId: number; contactId: { value: number, label: string }, begin: string; end: string };

    @Component({
        name: 'RequestCorrectionPopup',
        components: {
            DateRangeSelect,
            AppSearchTiny,
            FieldsetCloneable,
            PortunaBox,
            LoadingIndicator,
            FormTextarea,
            FormInputDate,
            FormSelect,
            FormRow,
        },
        methods: {
            getDayName,
            dayNamesEn()
            {
                return dayNamesEn
            },
            dayNames()
            {
                return dayNames
            },
            dateHelper
        },
        emits: ['setData', 'send-request'],
    })
    export default class RequestCorrectionPopup extends Vue
    {
        readonly $refs: {
            correctionForm: HTMLFormElement
            projectSelect: HTMLDivElement
            projectSelectMore: HTMLDivElement
            institutionSearch: AppSearchTiny
            institutionSearch_before: AppSearchTiny[] | null
            institutionSearch_after: AppSearchTiny[] | null
        };

        @TimeTrackerStore.Getter('isLoggedIn') isLoggedIn: boolean;

        @Prop({
            type: String,
            required: false,
        }) date: string;

        @Prop({
            type: Number,
            required: true,
        }) employee: number;

        CORRECTION_ADD_WORK_TIME_AND_BREAKS = CORRECTION_ADD_WORK_TIME_AND_BREAKS;

        hasContact = false;

        correctionTypes = {
            edit: 0,
            addBreak: 1,
            removeBreak: 2,
            retract: 3,
            editProject: 4,
            removeProject: 5,
        };

        correctionType: number = this.correctionTypes.edit;

        correctionEntryId: number = 0;

        correctionProjectEntryIds: string = '';

        correctionProjectId: number = -1;

        correctionContactId: { value: number, label: string } = {
            value: 0,
            label: 'Intern',
        };

        correctionNewStamp: string = '';

        newProjectBeginStamp: string = '';

        newProjectEndStamp: string = '';

        timeEntries: CorrectionRequestTime[] = [];

        breaks: ITimeTrackerTrackedTime[] = [];

        projectEntries: ITimeTrackerTrackedTimeCorrection[] = [];

        isSuperior: boolean = false;

        projects: ITimeTrackerProject[] = [];

        breakDeduction: boolean = false;

        loading: boolean = true;

        variantPrompt: boolean = true;

        correctionVariant: CorrectionVariant = 'time';

        today = <string>dateHelper('Y-m-d');

        hasProject: boolean = false;

        noApprovalRequired: boolean = false;

        requestAtWork: boolean = false;

        newBegin: string = '';

        newEnd: string = '';

        newBreaks: { begin: string; end: string }[] = [];

        projectFrameChanges: { before: Nullable<ProjectFrameChange>; after: Nullable<ProjectFrameChange> } = {
            before: null, after: null
        };

        projectSelectScrollY: number = 0;

        projectSelectScrollable: boolean = false;

        newDate: string = '';

        calculateNonWorkdays: boolean = false;

        calculateBeforeWorkStart: boolean = false;

        calculateAfterWorkEnd: boolean = false;

        allowWorkOutsideWorkTime: boolean = false;

        workDays = {} as Record<TDayNames, Nullable<{ start: string; end: string; }>>;

        get dayName()
        {
            return getDayName(this.date || this.today);
        }

        get buttons(): PopupButton[]
        {
            return [
                popupDefaultCancelButton,
                {
                    type: 'primary',
                    title: 'Beantragen',
                    icon: 'assignment',
                    cmd: () => this.sendRequest(),
                },
            ];
        }

        get superiorButtons(): PopupButton[]
        {
            let buttons = [
                popupDefaultCancelButton,
            ];

            const disabled = this.isProjectCorrection && !this.hasProjectChanges;

            if (this.isProjectCorrection)
            {
                buttons.push({
                    type: 'apply',
                    title: 'Zwischenspeichern',
                    icon: 'save',
                    disabled,
                    cmd: () => this.sendRequest(false),
                });
            }

            buttons.push({
                type: 'success',
                title: 'Speichern',
                icon: 'save',
                disabled,
                cmd: () => this.sendRequest(),
            });

            return buttons;
        }

        get minMaxNewEntries(): {min: Nullable<string>; max: Nullable<string>}
        {
            return {
                min: this.newBegin ? this.today + ' ' + this.newBegin : null,
                max: this.newEnd ? this.today + ' ' + this.newEnd : null,
            };
        }

        get minMaxProjectTimes()
        {
            let dateSuffix = this.today + ' ';
            const begin    = dateHelper('H:i', (this.selectedProjectChange.gapBefore?.begin || this.selectedProjectChange.entry?.begin));
            const end      = dateHelper('H:i', (this.selectedProjectChange.gapAfter?.end || this.selectedProjectChange.entry?.end));

            return {
                begin: {
                    min: dateSuffix + begin,
                    max: dateSuffix + (this.newProjectEndStamp || end),
                },
                end: {
                    min: dateSuffix + (this.newProjectBeginStamp || begin),
                    max: dateSuffix + end,
                },
            };
        }

        get selectedProjectChange()
        {
            if (!this.correctionProjectEntryIds)
            {
                return {
                    gapBefore: null,
                    entry: null,
                    gapAfter: null,
                };
            }

            for (const index in this.projectEntries)
            {
                if (!this.projectEntries.hasOwnProperty(index))
                {
                    continue;
                }

                const _index = parseInt(index);
                const entry  = this.projectEntries[_index];

                if (this.getRangeKey(entry) === this.correctionProjectEntryIds)
                {
                    const gapBefore = this.projectEntries[_index - 1] || null;
                    const gapAfter  = this.projectEntries[_index + 1] || null;

                    return {
                        gapBefore: gapBefore?.project_id === 0 && gapBefore.end === entry.begin ? gapBefore : null,
                        entry,
                        gapAfter: gapAfter?.project_id === 0 && gapAfter.begin === entry.end ? gapAfter : null,
                    };
                }
            }

            return {
                gapBefore: null,
                entry: null,
                gapAfter: null,
            };
        }

        get isProjectCorrection()
        {
            return (this.hasProject || this.hasContact) && this.correctionVariant === 'project';
        }

        get correctionDisabled()
        {
            return this.correctionTypes.edit === this.correctionType && !this.correctionEntryId;
        }

        get newStampRequired()
        {
            return !this.isProjectCorrection || !!this.correctionType;
        }

        get messageRequired()
        {
            if (this.isProjectCorrection && this.correctionTypes.edit === this.correctionType)
            {
                return this.newStampRequired || !!this.correctionNewStamp;
            }

            return true;
        }

        get correctionTypeOptions()
        {
            return {
                [this.correctionTypes.edit]: 'Bestehende Einträge bearbeiten',
                [this.correctionTypes.addBreak]: 'Fehlende Pause hinzufügen',
                [this.correctionTypes.removeBreak]: 'Bestehende Pause entfernen',
            };
        }

        get timeEntryOptions(): SelectOption[]
        {
            return this.filterByStampAndPatrol(this.timeEntries).map(entry =>
            {
                let typeName = timeTrackerEntryTypes[entry.type];

                if (this.isProjectCorrection && entry.project_id && [WORK_BEGIN, BREAK_END].includes(parseInt(entry.type)))
                {
                    typeName += ' - ' + this.projectPairs[entry.project_id];
                }

                if (entry.type === '1' && (entry.circumstances === 'patrol' || entry.circumstances === 'patrol_correction') || entry.type === '2' && (entry.circumstances === 'patrol' || entry.circumstances === 'patrol_correction'))
                {
                    const description = typeName === 'Arbeitsbeginn' ? 'Dienstgangbeginn' : 'Dienstgangende';

                    return {
                        value: entry.id,
                        label: `${description} - ${dateHelper('H:i:s', entry.stamp)}`,
                    };
                }

                return {
                    value: entry.id,
                    label: `${typeName} - ${dateHelper('H:i:s', entry.stamp)}`,
                };
            });
        }

        get projectPairs()
        {
            let projects = {0: 'Projektlücke'};

            for (let project of this.projects)
            {
                projects[project.id] = this.getProjectTitle(project);
            }

            return projects;
        }

        get projectOptions(): SelectOption[]
        {
            const projects: SelectOption[] = this.projects.map(project =>
            {
                return {
                    value: project.id,
                    label: this.getProjectTitle(project),
                };
            });

            projects.unshift({
                value: 0,
                label: 'Projektlücke',
            });

            return projects;
        }

        get projectOptionsWithoutSelected(): SelectOption[]
        {
            return this.projectOptions.map(option => Object.assign({
                disabled: option.value === this.correctionProjectId
            }, option));
        }

        get projectWorkTimeOptions()
        {
            let correction: SelectOption[] = [];
            let deletion: SelectOption[]   = [];

            for (const entry of this.projectEntries)
            {
                const stampBegin = dateHelper('H:i:s', entry.begin);
                const begin      = dateHelper('H:i', entry.begin);
                const stampEnd   = dateHelper('H:i:s', entry.end);
                const end        = dateHelper('H:i', this.breakDeduction ? entry.new_end! : entry.end);
                const key        = this.getRangeKey(entry);

                let option: SelectOption = {
                    value: key,
                    label: '',
                };
                if (this.hasProject)
                {
                    option.label = `${this.projectPairs[entry.project_id]} - ${begin} bis ${end}`;
                }
                else
                {
                    option.label = `${entry.contactName} - ${begin} bis ${end}`;
                }
                option.attributes  = {title: `${stampBegin} bis ${stampEnd}`};

                if (this.breakDeduction && entry.break!)
                {
                    option.label += ' (abzgl. ' + entry.break_string + ' Pause)';
                    option.attributes.title += {title: ` - ${entry.break_string} automatischer Pausenabzug`};
                }

                correction.push(option);

                if (entry.project_id)
                {
                    deletion.push(option);
                }
            }

            return {
                correction,
                deletion,
            };
        }

        get workDaysList()
        {
            return getWorkDaysAndHoursStringByWorkDays(this.workDays);
        }

        getRangeKey(entry: ITimeTrackerTrackedTime)
        {
            return `${entry.beginId}|${entry.endId}`;
        }

        get breakOptions()
        {
            let options: SelectOption[] = [];

            for (const entry of this.breaks)
            {
                let begin = dateHelper('H:i:s', entry.begin);
                let end   = entry.end ? dateHelper('H:i:s', entry.end) : '--:--';

                options[`${entry.beginId}|${entry.endId}`] = `Pause von ${begin} bis ${end}`;
            }

            return options;
        }

        get selectedProjectChangeData()
        {
            return {
                projectId: this.selectedProjectChange.entry?.project_id || 0,
                contactId: this.selectedProjectChange.entry?.contact_id || 0,
                contactName: this.selectedProjectChange.entry?.contactName || 'Intern',
                begin: this.selectedProjectChange.entry?.begin ? dateHelper('H:i', this.selectedProjectChange.entry.begin) : '',
                end: this.selectedProjectChange.entry?.end ? dateHelper('H:i', this.selectedProjectChange.entry.end) : '',
            }
        }

        get hasProjectChanges(): boolean
        {
            if (!this.correctionProjectEntryIds)
            {
                return false;
            }

            return this.correctionProjectId !== this.selectedProjectChangeData.projectId
                || this.newProjectBeginStamp !== this.selectedProjectChangeData.begin
                || this.newProjectEndStamp !== this.selectedProjectChangeData.end
                || this.correctionContactId.value !== this.selectedProjectChangeData.contactId;
        }

        get actualDate()
        {
            return this.date ? this.date : this.newDate;
        }

        @Watch('newDate')
        watchNewDate()
        {
            this.initCorrectionPopup();
        }

        @Watch('correctionProjectEntryIds')
        watchCorrectionProjectEntryIds()
        {
            this.correctionProjectId = this.selectedProjectChangeData.projectId;
            this.correctionContactId.value = this.selectedProjectChangeData.contactId;
            this.correctionContactId.label = this.selectedProjectChangeData.contactName;

            this.$nextTick(() => {
                this.newProjectBeginStamp = this.selectedProjectChangeData.begin;
                this.newProjectEndStamp   = this.selectedProjectChangeData.end;
            });

            this.handleButtons();
        }

        @Watch('hasProjectChanges')
        watchHasProjectChanges()
        {
            this.handleButtons();
        }

        @Watch('newProjectBeginStamp')
        watchNewProjectBeginStamp(newValue: string, oldValue: string)
        {
            if (this.selectedProjectChangeData.begin === newValue)
            {
                return;
            }

            if (!newValue)
            {
                this.$nextTick(() => {
                    this.newProjectBeginStamp = this.selectedProjectChangeData.begin;
                });

                return;
            }

            if (!this.projectFrameChanges.before)
            {
                if (this.selectedProjectChangeData.begin < newValue)
                {
                    this.projectFrameChanges.before = {
                        projectId: this.correctionProjectId ? 0 : -1,
                        contactId: {
                            value: 0,
                            label: 'Intern',
                        },
                        begin: this.selectedProjectChangeData.begin,
                        end: newValue,
                    };
                }

                return;
            }

            if (newValue <= this.projectFrameChanges.before.begin)
            {
                this.projectFrameChanges.before = null;

                return;
            }

            this.projectFrameChanges.before.end = newValue;
        }

        @Watch('newProjectEndStamp')
        watchNewProjectEndStamp(newValue: string)
        {
            if (this.selectedProjectChangeData.end === newValue)
            {
                return;
            }

            if (!newValue)
            {
                this.$nextTick(() => {
                    this.newProjectEndStamp = this.selectedProjectChangeData.end;
                });

                return;
            }

            if (!this.projectFrameChanges.after)
            {
                if (newValue < this.selectedProjectChangeData.end)
                {
                    this.projectFrameChanges.after = {
                        projectId: this.correctionProjectId ? 0 : -1,
                        begin: newValue,
                        contactId: {
                            value: 0,
                            label: 'Intern',
                        },
                        end: this.selectedProjectChangeData.end,
                    };
                }

                return;
            }

            if (this.projectFrameChanges.after.end <= newValue)
            {
                this.projectFrameChanges.after = null;

                return;
            }

            this.projectFrameChanges.after.begin = newValue;
        }

        @Watch('correctionNewStamp')
        @Watch('correctionProjectId')
        @Watch('correctionContactId', {deep: true})
        watchCorrectionData()
        {
            this.handleButtons();

            if (!this.correctionNewStamp)
            {
                this.$nextTick(() =>
                {
                    this.$store.dispatch('form/resetError', {errorName: 'new_stamp'});
                });
            }
        }

        @Watch('loading')
        @Watch('isProjectCorrection')
        @Watch('projectWorkTimeOptions')
        watchProjectWorkTimeOptions()
        {
            this.$nextTick(this.updateProjectSelectDimensions);
        }

        created()
        {
            this.emitter.emit('setButtons', [popupDefaultCancelButton]);

            if (this.date)
            {
                this.initCorrectionPopup();
            }
        }

        filterByStampAndPatrol(data)
        {
            return Object.values(data.reduce((uniqueEntries, currentEntry) =>
            {
                if (
                    !uniqueEntries[currentEntry.stamp] ||
                    currentEntry.circumstances === 'patrol' ||
                    currentEntry.circumstances === 'patrol_correction'
                )
                {
                    uniqueEntries[currentEntry.stamp] = currentEntry;
                }
                return uniqueEntries;
            }, {}));
        }

        initCorrectionPopup()
        {
            let init = (hasProject: boolean, hasContact: boolean) =>
            {
                this.hasProject = hasProject;
                this.hasContact    = hasContact;
                this.variantPrompt = hasProject || hasContact;

                if (this.variantPrompt)
                {
                    this.handleButtons();
                }
                else if (this.newDate !== '' || this.date)
                {
                    this.fetch();
                }
            };

            if (this.newDate !== '' || this.date)
            {
                this.axios.get(`/employee/time-tracker/correction/fetch-request-data/employee/${this.employee}/date/${this.actualDate}`).then(response =>
                {
                    if (response.data.status !== XHR_STATUS_DEFAULT)
                    {
                        throw response;
                    }

                    const {data}                  = response.data;
                    this.noApprovalRequired       = data.no_approval_required;
                    this.requestAtWork            = !!data.request_at_work;
                    this.workDays                 = data.work_days;
                    this.allowWorkOutsideWorkTime = data.allow_work_outside_work_time_current;
                    this.calculateNonWorkdays     = data.calculate_non_workdays;
                    this.calculateBeforeWorkStart = data.calculate_before_work_start;
                    this.calculateAfterWorkEnd    = data.calculate_after_work_end;

                    init(data.project_enabled, data.contact_enabled);
                })
                .catch(() => init(false, false));
            }

        }

        fetch()
        {
            this.axios.get(`/employee/time-tracker/correction/request/variant/${this.correctionVariant}/timestamp/${this.actualDate}/employee/${this.employee}`)
            .then(response =>
            {
                if (response.data.status !== XHR_STATUS_DEFAULT)
                {
                    throw response;
                }

                const {data} = response.data;

                this.$store.dispatch('form/setFilter', data.filter);

                // reset project members
                this.correctionProjectEntryIds  = '';
                this.correctionProjectId        = -1;
                this.correctionContactId = {
                    value: 0,
                    label: 'Intern',
                };
                this.newProjectBeginStamp       = '';
                this.newProjectEndStamp         = '';
                this.projectFrameChanges.before = null;
                this.projectFrameChanges.after  = null;

                // set data
                this.timeEntries    = data.timeEntries;
                this.breaks         = data.breaks;
                this.projectEntries = data.projectEntries;
                this.isSuperior     = data.isSuperior;
                this.projects       = data.projects;
                this.breakDeduction = data.break_deduction;
                this.hasContact     = data.isContactAllowed;

                if (this.isProjectCorrection)
                {
                    this.correctionType = this.correctionTypes.editProject;
                }

                // fix timeEntries & keep corrupted entry time for new set of time-entries
                if (this.timeEntries.length === 1)
                {
                    const corruptedEntry = this.timeEntries[0];
                    const corruptedEntryType = parseInt(corruptedEntry.type);

                    if (corruptedEntryType !== WORK_BEGIN)
                    {
                        const corruptedEntryTime = corruptedEntry.stamp.substring(11, 16);

                        if (corruptedEntryType === WORK_END)
                        {
                            this.newEnd = corruptedEntryTime;
                        }

                        if (corruptedEntryType === BREAK_BEGIN)
                        {
                            this.newBreaks = [{begin: corruptedEntryTime, end: ''}];
                        }

                        if (corruptedEntryType === BREAK_END)
                        {
                            this.newBreaks = [{begin: '', end: corruptedEntryTime}];
                        }

                        this.timeEntries = [];
                    }
                }

                this.handleButtons();
            })
            .catch(error => {
                errorHandler(error);
                this.emitter.emit('close');
            })
            .finally(() => {
                this.loading = false;
                this.emitter.emit('lazy-load-focus');
            });
        }

        handleButtons()
        {
            if (!this.variantPrompt)
            {
                if (this.isProjectCorrection)
                {
                    this.emitter.emit('setTitle', 'Projektzeitkorrektur');
                }
                else
                {
                    this.emitter.emit('setTitle', this.isSuperior ? 'Zeitkorrektur' : 'Zeitkorrektur beantragen');
                }

                this.emitter.emit('setButtons', this.isSuperior || this.isProjectCorrection ? this.superiorButtons : this.buttons);

                return;
            }

            const setVariant = (type: CorrectionVariant) =>
            {
                this.correctionVariant = type;
                this.variantPrompt     = false;

                this.fetch();
            };

            const isFutureOrToday = this.today <= this.date;

            this.emitter.emit('setTitle', 'Zeitkorrektur');

            let tooltip = null;

            if (this.isLoggedIn && !this.requestAtWork)
            {
                tooltip = 'Sie dürfen Ihre Zeiten nur während der Pause oder nach der Arbeit korrigieren.';
            }
            else if (isFutureOrToday)
            {
                tooltip = 'Hier können Sie ab morgen eine Korrektur beantragen.';
            }

            this.emitter.emit('setButtons', [
                popupDefaultCloseButton,
                {
                    type: 'primary',
                    title: 'Arbeitszeitkorrektur',
                    icon: 'play_circle_outline',
                    disabled: isFutureOrToday || this.isLoggedIn && !this.requestAtWork,
                    tooltip,
                    cmd: () => setVariant('time'),
                },
                {
                    type: 'primary',
                    title: 'Projektzeitkorrektur',
                    icon: 'work_history',
                    cmd: () => setVariant('project'),
                },
            ]);
        }

        sendRequest(close: boolean = true)
        {
            let formData = getFormData(this.$refs.correctionForm);

            formSubmit(
                `/employee/time-tracker/correction/request/variant/${this.correctionVariant}/timestamp/${this.actualDate}/employee/${this.employee}`,
                parseFormData(formData),
            )
            .then(data =>
            {
                TopMessageHandler.success((data && data.message) || 'Die Korrektur wurde beantragt.');

                this.emitter.emit('send-request');

                if (close)
                {
                    this.emitter.emit('close')
                }
                else
                {
                    this.fetch();
                }
            })
            .catch(console.error);
        }

        getProjectTitle(project: ITimeTrackerProject)
        {
            return project.title + (project.active ? '' : ' (deaktiviert)');
        }

        setCorrectionProjectEntryIds(ids: string)
        {
            if (this.correctionProjectEntryIds === ids)
            {
                return;
            }

            const setEntryIds = () =>
            {
                this.$store.dispatch('form/resetAllErrors');

                this.correctionProjectEntryIds  = ids;
                this.projectFrameChanges.before = null;
                this.projectFrameChanges.after  = null;
            };

            if (!this.correctionProjectEntryIds || !this.hasProjectChanges)
            {
                setEntryIds();

                return;
            }

            applyChangesPrompt()
            .then(() => this.sendRequest(false))
            .catch(setEntryIds);
        }

        removeProjectFrameChange(key: 'before' | 'after')
        {
            // reset begin or end change
            if (key === 'before')
            {
                this.newProjectBeginStamp = this.selectedProjectChangeData.begin;

                TopMessageHandler.info('Der Beginn wurde zurückgesetzt.');
            }
            else if (key === 'after')
            {
                this.newProjectEndStamp = this.selectedProjectChangeData.end;

                TopMessageHandler.info('Das Ende wurde zurückgesetzt.');
            }

            this.projectFrameChanges[key] = null;
        }

        removeProjectEntry()
        {
            TopMessageHandler.info('Anstelle des zuvor ausgewählten Projektes entsteht nun eine Projektlücke.');

            this.correctionProjectId = 0;
        }

        scrollToNextProjects()
        {
            this.$refs.projectSelect.scrollTo({
                top: this.$refs.projectSelect.clientHeight - this.$refs.projectSelectMore.clientHeight,
                behavior: 'smooth',
            });
        }

        updateProjectSelectDimensions()
        {
            this.projectSelectScrollY    = this.$refs.projectSelect?.scrollTop || 0;
            this.projectSelectScrollable = this.$refs.projectSelect?.clientHeight < this.$refs.projectSelect?.scrollHeight;
        }

        setCorrectionContact(entry: { value: number, label: string } = {
            value: 0,
            label: 'Intern',
        })
        {
            this.correctionContactId = entry;
            this.clearInstitutionSearch();
        }

        changeCorrectionContact(key: 'before' | 'after', entry: { value: number, label: string } = {
            value: 0,
            label: 'Intern',
        })
        {

            if (this.projectFrameChanges[key] !== null)
            {
                //@ts-ignore
                this.projectFrameChanges[key].contactId = entry;
            }
            this.clearInstitutionSearch(key);
        }

        clearInstitutionSearch(type: 'before' | 'after' | 'main' = 'main')
        {
            if (type === 'main')
            {
                this.$refs.institutionSearch.searchValue = '';
                this.$refs.institutionSearch.$refs.input.$refs.input.blur();
            }
            else if (type === 'before' && this.$refs.institutionSearch_before?.[0])
            {
                this.$refs.institutionSearch_before[0].searchValue = '';
                this.$refs.institutionSearch_before[0].$refs.input.$refs.input.blur();
            }
            else if (type === 'after' && this.$refs.institutionSearch_after?.[0])
            {
                this.$refs.institutionSearch_after[0].searchValue = '';
                this.$refs.institutionSearch_after[0].$refs.input.$refs.input.blur();
            }
        }

        get dateDayName(): string
        {
            if (!this.date)
            {
                return '';
            }

            return getDateInformation(this.date).dayName;
        }
    }
</script>